import { createTheme } from "@mui/material/styles";
import { keyframes } from "@emotion/react";

const bounce = keyframes`
  0% {
    transform: 'translateX(0)'
  },
  20% {
    transform: 'translateX(0)'
  },
  40% {
    transform: 'translateX(-30px)'  
  },
  50% {
    transform: 'translateX(0)'
  },
  60% {
    transform: 'translateX(-15px)'
  }
  80% {
    transform: 'translateX(0)'
  },
  100% {
    transform: 'translateX(0)'
  },
`;

export const skbv = createTheme({
  palette: {
    primary: {
      main: "#1b5f4b",
      light: "#438d6d",
    },
    secondary: {
      main: "#a5432f",
    },
    error: {
      main: "#e30613",
    },
    info: {
      main: "#0684c2",
    },
    success: {
      main: "#438d6d",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: "aktiv-grotesk, sans-serif",
    fontWeight: 'normal',
    h1: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "32px",
      color:  "#333333",
      fontWeight: "500",
      textTransform: "uppercase",
      
      '@media (min-width: 768px)': {
        fontSize: "40px",
      },
      
      '@media (min-width: 1024px)': {
        fontSize: "44px",
      },
      
      '@media (min-width: 1200px)': {
        fontSize: "48px",
      }
    },
    h2: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "20px",
      color:  "#333333",
      fontWeight: "500",
      textTransform: "uppercase",
      
      '@media (min-width: 768px)': {
        fontSize: "20px",
      },
      
      '@media (min-width: 1024px)': {
        fontSize: "22px",
      },
      
      '@media (min-width: 1200px)': {
        fontSize: "24px",
      }
    },
    h3: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "22px",
      color:  "#333333",
      fontWeight: "700",
      textTransform: "uppercase",
    },
    h4: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "20px",
      fontWeight: "700",
      textTransform: "uppercase",
    },
    body1: {
      fontFamily: "aktiv-grotesk, sans-serif",
      fontWeight: 300,
      fontSize: "15px",
      color: '#333333',
    },
    body2: {
      fontFamily: "aktiv-grotesk, sans-serif",
      fontWeight: 300,
      fontSize: "13px",
      color: '#333333',
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#F8F8F2",
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        // the slot name defined in the `slot` and `overridesResolver` parameters
        // of the `styled` API
        root: {
          color: "#111111",
          fontFamily: "aktiv-grotesk, sans-serif",
          fontSize: "16px",
          fontWeight: "500",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 16,
          color: "#ffffff",
          textTransform: "none",
          fontFamily: "aktiv-grotesk, sans-serif",
          fontSize: "16px",
          fontWeight: "700",
          padding: "2px 16px",

          '&::after': {
            fontSize: '20px',
            display: 'inline-block',
            verticalAlign: 'middle',
            marginLeft: '8px',
            content: '"➝"'
          },
          '&::hover': {
            '&::after': {
              animation: `${bounce} 1s infinite ease`,
            }
          }
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: "aktiv-grotesk, sans-serif",
          fontSize: "16px",
          fontWeight: "400",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        }
      }
    }
  },
});

export const nordrum = createTheme({
  palette: {
    primary: {
      main: "#65b32e",
      light: "#438d6d",
    },
    secondary: {
      main: "#a5432f",
    },
    error: {
      main: "#e30613",
    },
    info: {
      main: "#0684c2",
    },
    success: {
      main: "#438d6d",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: "poppins, sans-serif",
    fontWeight: 'normal',
    h1: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "32px",
      color:  "#333333",
      fontWeight: "500",
      textTransform: "uppercase",
      
      '@media (min-width: 768px)': {
        fontSize: "40px",
      },
      
      '@media (min-width: 1024px)': {
        fontSize: "44px",
      },
      
      '@media (min-width: 1200px)': {
        fontSize: "48px",
      }
    },
    h2: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "20px",
      color:  "#333333",
      fontWeight: "500",
      textTransform: "uppercase",
      
      '@media (min-width: 768px)': {
        fontSize: "20px",
      },
      
      '@media (min-width: 1024px)': {
        fontSize: "22px",
      },
      
      '@media (min-width: 1200px)': {
        fontSize: "24px",
      }
    },
    h3: {
      fontFamily: "united-sans, sans-serif",
      fontSize: "22px",
      color:  "#333333",
      fontWeight: "700",
      textTransform: "uppercase",
    },
    h4: {
      fontFamily: "poppins, sans-serif",
      fontSize: "20px",
      fontWeight: "700",
      textTransform: "uppercase",
    },
    body1: {
      fontFamily: "aktiv-grotesk, sans-serif",
      fontWeight: 300,
      fontSize: "16px",
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#FBFBF9",
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        // the slot name defined in the `slot` and `overridesResolver` parameters
        // of the `styled` API
        root: {
          color: "#111111",
          fontFamily: "poppins, sans-serif",
          fontSize: "16px",
          fontWeight: "500",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 20,
          color: "#ffffff",
          textTransform: "none",
          fontFamily: "poppins, sans-serif",
          fontSize: "16px",
          fontWeight: "500",
          padding: "2px 16px",

          '&::after': {
            fontSize: '20px',
            display: 'inline-block',
            verticalAlign: 'middle',
            marginLeft: '8px',
            content: '"➝"'
          },
          '&::hover': {
            '&::after': {
              animation: `${bounce} 1s infinite ease`,
            }
          }
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: "poppins, sans-serif",
          fontSize: "16px",
          fontWeight: "400",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        }
      }
    }
  },
});
